import PropTypes from "prop-types";

// project imports
import DrawerHeaderStyled from "./DrawerHeaderStyled";
import Box from "@mui/material/Box";
import Logo from "../../../../assets/images/img.png";
import minLogo from "../../../../assets/images/Logo.png";

// ==============================|| DRAWER HEADER ||============================== //

export default function DrawerHeader({open}) {
    return (
        <DrawerHeaderStyled
            open={open}
            sx={{
                minHeight: "60px",
                width: "initial",
                paddingTop: "8px",
                paddingBottom: "8px",
                paddingLeft: open ? "24px" : 0,
            }}
        >
            {open ? (
                <Box component="img" src={Logo} height={30}/>
            ) : (
                <Box component="img" src={minLogo} height={30}/>
            )}
        </DrawerHeaderStyled>
    );
}

DrawerHeader.propTypes = {open: PropTypes.bool};
